import { render, staticRenderFns } from "./FiltrarBanca.vue?vue&type=template&id=5eb4a961"
import script from "./FiltrarBanca.vue?vue&type=script&lang=ts"
export * from "./FiltrarBanca.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports